import { render, staticRenderFns } from "./LogoEditor.vue?vue&type=template&id=47e2a4ca&scoped=true"
import script from "./LogoEditor.vue?vue&type=script&lang=ts"
export * from "./LogoEditor.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47e2a4ca",
  null
  
)

export default component.exports